import { BIEventsAnalyticsHandler } from './BIEventsAnalyticsHandler';
import { FirebaseAnalyticsHandler } from './FirebaseAnalyticsHandler';

export class AnalyticsClient {
  public firebase: FirebaseAnalyticsHandler;
  public BIEvent: BIEventsAnalyticsHandler;

  constructor(
    firebase: FirebaseAnalyticsHandler,
    BIEvent: BIEventsAnalyticsHandler,
  ) {
    this.firebase = firebase;
    this.BIEvent = BIEvent;
  }
}
